import { SessionActorType } from "doxecure-commons/doxecureTypes";

import { Dashboard } from "@containers/generics/Dashboard";
import { useAuthContext } from "@hooks/useAuthContext";
import { okOrError, optlog, defaultSectionInformations } from "@utils/functions";

export const DraftView = () => {
    const { connectedProfileId } = useAuthContext();
    optlog(`+++ DraftView initialized with profile ID '${connectedProfileId}'`) ;

    return okOrError(
        connectedProfileId,
        (<Dashboard 
            title="Brouillons"
            emptyMessage="Pas de brouillons"
            category="draft"
            roles={[SessionActorType.Creator, SessionActorType.Expeditor]} 
            sectionInfos={defaultSectionInformations} 
        />),
        false,
        "Impossible d'afficher la liste des brouillons car l'identifiant de profil de la personne connectée n'a pas pu être récupéré.",
        "Connexion invalide"
    ) ;
};
